/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  VueSessionCookieService
} from '@vue/vueframework';

@Injectable({
  providedIn: 'root'
})
export class SiteAccessChecker {
  /**
   * Key used for saving the realmDetail to session.
   */
  public static readonly realmDetail: string = 'realmDetail';

  public constructor(
    private router: Router,
    private vueSessionCookieService: VueSessionCookieService,
  ) {}

  public async canActivate(): Promise<boolean> {
    const realmDetailInCookie = this.vueSessionCookieService.getAttribute(
      SiteAccessChecker.realmDetail,
      'VUE'
    );

    const siteIdCookie = this.vueSessionCookieService.getAttribute('siteID', 'VUE');
    const siteId = Number(siteIdCookie);
    const userSiteId = Number(JSON.parse(realmDetailInCookie).siteID);

    const allowed = (siteId === userSiteId);
    if (!allowed) {
      this.router.navigate([ '/siteAffiliateNotAuthorized' ]);
    }
    return allowed;
  }
}
